export { DecoratedFrame } from './decorated-frame';
export type { DecoratedFrameProps } from './decorated-frame';
